import { createApi } from "@reduxjs/toolkit/query/react";
import { cacheDurationSeconds } from "common/constants";
import { baseQueryWithReauth } from "./utils/constants";
import {
	TransactionsParams,
	TransactionsResponse,
} from "./utils/interfaces";
import moment from "moment"; 

const getUrlParams = (args) => {
	const allowedParams = ["userName", "endTime", "limit", "startTime", "offset", "sortBy", "filterBy"];
	const queryParams: string[] = [];
	Object.keys(args).forEach(key => {
		if (allowedParams.includes(key) && args[key]) {
			queryParams.push(`${key}=` + args[key]);
		}
	});
	return queryParams.join("&");
};
// &currentTime=${moment(new Date()).format()}
export const transactionsApi = createApi({
	reducerPath: "transactions",
	baseQuery: baseQueryWithReauth,
	keepUnusedDataFor: cacheDurationSeconds,
	endpoints: (builder) => ({
		getTransactions: builder.query<TransactionsResponse, TransactionsParams>({
			query: (args) => ({
				url: `get-transactions-v2?${getUrlParams(args)}`,
			}),
		}),
		fefundTransaction: builder.mutation<any, any>({
			query: (data) => {
				const { transactionId, chargePointId, refundAmount, refundMessage } = data;
				return {
					url: `refund-transaction`,
					method: "PUT",
					body: { transactionId: transactionId, "locationId.stationId.chargePointId": chargePointId,
					refundAmount: refundAmount, refundMessage: refundMessage },
				};
			},
		}),
	}),
});

export const {
	useGetTransactionsQuery,
	useFefundTransactionMutation
} = transactionsApi;
